import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface CrmonceRouteProps {
  children: React.ReactNode;
}

const CrmonceRoute: React.FC<CrmonceRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  // Debug logging
  console.log('CrmonceRoute - loading:', loading);
  console.log('CrmonceRoute - user:', user);
  console.log('CrmonceRoute - user email:', user?.email);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has CRMONCE email
  if (!user.email || !user.email.toLowerCase().includes('crmonce.com')) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h1>
          <p className="text-gray-600 mb-4">
            You don't have permission to access this page. Only CRMONCE team members can access this feature.
          </p>
          <button
            onClick={() => window.history.back()}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default CrmonceRoute;
